import { createAsyncThunk } from '@reduxjs/toolkit';
import { storeResources } from '../../resources';
import { getTickets } from '../../../services/tickets';
import {
  IGetTicketParams,
  IGetTicketResponse,
  ITicketsParams,
} from '../../../services/tickets/types';

interface IProps {
  params: ITicketsParams;
  isSearchAction?: boolean;
}

export const ThunkGetTickets = createAsyncThunk<IGetTicketResponse, IProps>(
  `${storeResources.TICKETS}/getTickets`,
  ({ params, isSearchAction }) => {
    const reqParams: IGetTicketParams = {
      search: params.search,
      statusId: params.statusId,
      ticketStatusId: params.ticketStatusId,
      isClosed: params.isClosed,
      _start: params.page * params.pageSize,
      _end: params.page * params.pageSize + params.pageSize,
      _sort: params._sort,
      _order: params._order,
    };

    if (isSearchAction) {
      reqParams._start = undefined;
      reqParams._end = undefined;
    }

    return getTickets(reqParams).then(res => ({
      tickets: res.data,
      total: res.headers['x-total-count'],
    }));
  },
);
